import React from 'react';

const ContactInfoCard = ({ settings, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">联系方式</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium mb-1">电话</label>
        <input type="text" value={settings.phone}
          onChange={e => onChange('phone', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">邮箱</label>
        <input type="email" value={settings.email}
          onChange={e => onChange('email', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium mb-1">地址</label>
        <input type="text" value={settings.address}
          onChange={e => onChange('address', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Facebook</label>
        <input type="text" value={settings.facebook}
          onChange={e => onChange('facebook', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="https://facebook.com/..." />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Telegram</label>
        <input type="text" value={settings.telegram}
          onChange={e => onChange('telegram', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="@yourshop" />
      </div>
    </div>
  </div>
);

export default ContactInfoCard;